import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ApiProvider } from './contexts/ApiContext';
import { AuthProvider } from './contexts/AuthContext';
import { CashDrawerProvider } from './contexts/CashDrawerContext';
import { DebugDataProvider } from './contexts/DebugDataContext';
import { ModulesProvider } from './contexts/ModulesContext';
import { ThemeProvider } from './theme';
import './i18n';
import './index.css';
// Shared data-row styling for every table in the app (WebGrid, antd, MUI).
import './styles/tableRows.css';
import reportWebVitals from './reportWebVitals';

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
    });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error(
        "Root element not found. Make sure the element with ID 'root' exists in the DOM.",
    );
}
const root = createRoot(rootElement);
root.render(
    <BrowserRouter>
        <ThemeProvider>
            <AuthProvider>
                <ApiProvider>
                    <CashDrawerProvider>
                        <DebugDataProvider>
                            <ModulesProvider>
                                <App />
                            </ModulesProvider>
                        </DebugDataProvider>
                    </CashDrawerProvider>
                </ApiProvider>
            </AuthProvider>
        </ThemeProvider>
    </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
